import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import cookie from "react-cookies";
import { Button, Col, Result, Row, Steps } from "antd";
import { useNavigate } from "react-router-dom";
import TOTPProvisionForm from './totp/TOTPProvisionForm';
import TOTPActivateForm from './totp/TOTPActivateForm';
import AUTH from "../../constants/Auth";
const TOTPSetupWizardSteps = [{ title: 'Confirm Password' }, { title: 'Setup' }, { title: 'Success' }];
export default function TOTPSetupWizard() {
    const [currentStep, setCurrentStep] = useState(0);
    const [secret, setSecret] = useState('');
    const [url, setUrl] = useState('');
    const navigate = useNavigate();
    const onProvisionCompleted = (secret, url) => {
        setCurrentStep(1);
        setSecret(secret);
        setUrl(url);
    };
    const onActivateCompleted = () => {
        cookie.remove(AUTH.shouldSetup2FACookieName);
        setCurrentStep(2);
    };
    const exitSetup = () => {
        navigate('/app/home');
    };
    return (_jsxs("div", { children: [_jsx(Row, { children: _jsx(Col, { md: 24, children: _jsx(Steps, { current: currentStep, items: TOTPSetupWizardSteps }) }) }), _jsx(Row, { children: _jsxs(Col, { md: 24, children: [currentStep === 0 &&
                            _jsx(TOTPProvisionForm, { onCompleted: onProvisionCompleted }), currentStep === 1 &&
                            _jsx(TOTPActivateForm, { secret: secret, url: url, onCompleted: onActivateCompleted }), currentStep === 2 &&
                            _jsx("div", { children: _jsx(Row, { justify: "center", children: _jsx(Col, { xl: 12, style: { paddingTop: '15px' }, children: _jsx(Result, { status: "success", title: "Multi-factor authentication setup", subTitle: "You are all setup, next time you login you will need to use your authenticator", extra: [
                                                _jsx(Button, { onClick: exitSetup, type: "primary", htmlType: "submit", size: "large", children: "Back to SubTrux" })
                                            ] }) }) }) })] }) })] }));
}
